import Param from './param';
import Util from './module/libs/util';
import YoutubeManager from './module/libs/youtube';
import effectManager from './module/effect';
import globalNavi from './module/global/globalNavi';
import Btn from './module/global/btn';
import TransitionManager from './module/global/transition';
import topManager from './page/top';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';
import webglManager from './module/webgl/manager';
import MovieManager from './page/movie';
import LoaderManager from './page/loader';

const util = new Util();
const effect = new effectManager;

export default class Manager {
    constructor() {

        this.w = window.innerWidth;
        this.h = window.innerHeight;


        this.loader = new LoaderManager();
        this.loader.init();

        /* fps計測用 */
        // this.fps = new Stats();
        // this.fps.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
        // document.body.appendChild( this.fps.dom );

        /* fps低下対策 */
        this.fpsRate;

        /* class用 */
        this.param = new Param();
        this.effect;
        this.gNavi = new globalNavi();
        this.btn = new Btn();
        this.scroll;
        this.mouse;
        this.page; /* ページごとに読み込むのもを入れる */
        this.webgl = new webglManager(this.w,this.h);
        this.movie = new MovieManager();
        this.youtube = {
            player : "",
            status:{
                load : false,
                play : false,
                pause : true,
                mute  : false,
            }
        }
        this.transition = new TransitionManager();

        /* ステータス */

        this.status = {
            pageID : "",
            execution : "",
            update : {
                timestamp:0,
            },
            wheel:{
                flg : false,
                time : 0,
                sectionTimer:""
            }
        }

        this.conf = {
            wheel:{
                PAUSE : Useragnt.mobile? 60 : 60,
            }
        }


    }
    init(execution){ /* 初期化 */

        let _this = this;

        this.status.pageID = $("body").attr("id");
        this.status.execution = execution;
        TweenMax.set($("#l-root,.p-lowlayer"),{opacity:1});
        $('html,body').animate({ scrollTop: 0 }, '1');

        this.loadCommon();
        this.loadPage();
    }
    loadCommon(){ /* 共通で読み込むもの */

        this.effect = new effectManager();
        // this.scroll = new smoothScrollManager();
        this.mouse = new MouseManager();
        this.gNavi.init();
        if(!Useragnt.mobile) this.btn.init();
        this.transition.init();

        if(this.status.execution==="landing") this.webgl.init();
        let _this = this;

        setTimeout(()=>{
            _this.resize();
            // _this.scroll.init(_this.status.pageID);
            if(_this.status.execution==="landing") _this.render();
            setTimeout(()=>this.transition.show(),25e2)
        },1e2);
    }
    loadPage(){ /* ページごとに分岐するもの */

        switch(this.status.pageID){
            case "top":
                this.page = new topManager();
                this.page.init();
                this.movie.init();

                let _this = this;
                let _naviFlg = false;

                let _event = Useragnt.tablet ? "touchend":"click";

                $("#l-header-logo,.p-lowlayer-logo").on(_event,function(){

                    let _select = 0;
                    if(_select==_this.page.status.current) return;
                    if(_naviFlg) return;
                    _naviFlg = true;

                    _this.page.update("",_select,_this.page.status.current<_select?"next":"prev","pagetop");
                    _this.webgl.change(_this.page.status.current,_this.page.status.prevCurrent);
                    _this.gNavi.update(_this.page.status.current,_this.page.status.prevCurrent);
                    setTimeout(()=>_naviFlg = false,3e3)
                })

                if(!Useragnt.mobile) $(".js__pagenavi").on(_event,function(){
                    let _select = Number($(this).attr("data-select"));

                    if(_select==_this.page.status.current) return;
                    if(_naviFlg) return;
                    _naviFlg = true;

                    _this.page.update("",_select,_this.page.status.current<_select||_this.page.MAX==_this.page.status.current&&_select==0?"next":"prev");
                    _this.webgl.change(_this.page.status.current,_this.page.status.prevCurrent);
                    _this.gNavi.update(_this.page.status.current,_this.page.status.prevCurrent);
                    setTimeout(()=>_naviFlg = false,3e3)
                })

                // $(window).on("mousemove",function (e) {
                //     console.log("mouse",_this.movie.status.console.flg);
                //     if(_this.page.status.movieFlg){
                //         _this.movie.uiOpen();
                //     }
                //     _this.movie.status.console.time = 0;
                // });

                let _youtubeStop = ()=>{
                    this.page.status.movieFlg =  false;
                    this.page.$target.eq(this.page.status.current).addClass("is-current");
                    this.youtube.status.play = false;
                    this.youtube.player.pauseVideo();

                    this.webgl.playMovie(this.page.status.current,"stop")
                    this.movie.close();

                    setTimeout(()=>{
                        if(this.page.status.current==0){
                            this.page.mainvisual.show();
                            effect.show($("#l-scrolldown"),"show");
                        }else{
                            this.page.section.show(this.page.status.current)
                        }
                    },5e2);

                    setTimeout(()=> this.transition.show(),1e3);
                }

                let _onPlayerStateChange = (event)=>{

                    if(event.data==0){
                        $("#p-movie-console-play").removeClass("is-play");
                        // $("#p-movie-console-sound").removeClass("is-unmute");
                    }else if(event.data==1){
                        $("#p-movie-console-play").addClass("is-play");
                        // $("#p-movie-console-sound").addClass("is-unmute");
                    }

                    if(Useragnt.mobile&&event.data==2){/* SPは再生終了したら閉じる */
                        _youtubeStop();

                    }
                }

                _this.youtube.player =  new YT.Player(_this.param.youtube.domID, {
                    width: _this.width,
                    height: _this.height,
                    videoId: _this.param.youtube.id,
                    playerVars: {
                        'autoplay' : 0,
                        'html5': 1,
                        'modestbranding': 1,
                        'controls':0,
                        'rel':0,
                        'enablejsapi':1,
                        'showinfo':0,
                        'disablekb': 1,
                        'modestbranding':1,
                        'iv_load_policy':3

                    },
                    events: {
                        'onReady':()=>{
                            _this.youtube.status.load = true;
                            _this.youtube.player.setPlaybackQuality('hd1080');
                            _this.movie.status.seekbar.totalTime = _this.youtube.player.getDuration();

                            // console.log(_this.youtube.player,_this.youtube.player.getAvailableQualityLevels());

                        },
                        'onStateChange': _onPlayerStateChange
                    }

                });

                $("#p-kv-content-play,#p-btn-movie,#l-header-play").on(_event,function(){
                    if(_naviFlg||!_this.youtube.status.load) return;
                    _naviFlg = true;
                    _this.page.status.movieFlg =  true;
                    _this.page.$target.removeClass("is-current");

                    _this.youtube.status.play = true;
                    _this.youtube.player.seekTo(0);
                    _this.youtube.player.playVideo();

                    if(_this.page.status.current==0){
                        _this.page.mainvisual.out();
                        effect.show($("#l-scrolldown"),"out");
                    }else{
                        _this.page.section.out(_this.page.status.current)
                    }
                    setTimeout(()=>{
                        _this.transition.out();
                        _this.webgl.playMovie(_this.page.status.current,"play")
                    },5e2);
                    // setTimeout(()=>_this.movie.open(),1e3);
                    setTimeout(()=>_this.movie.open(),5e2);
                    setTimeout(()=>_naviFlg = false,3e3)
                })

                this.movie.$close.on(_event,function(){
                    if(_naviFlg) return;
                    _naviFlg = true;
                    _youtubeStop();
                    setTimeout(()=>_naviFlg = false,2e3)
                })


                let _$playBtn = $("#p-movie-console-play"),
                    _$soundBtn = $("#p-movie-console-sound");


                if(!Useragnt.mobile) this.movie.$playBtn.on(_event,()=>{
                    if(_this.youtube.status.play&&_$playBtn.hasClass("is-play")){
                        _$playBtn.removeClass("is-play");
                        _this.youtube.status.play = false;
                        _this.youtube.player.pauseVideo();
                        _$soundBtn.removeClass("is-unmute");
                        _this.youtube.player.mute();

                    }else{
                        _$playBtn.addClass("is-play");
                        _this.youtube.status.play = true;
                        _this.youtube.player.playVideo();
                        if(!_this.youtube.status.mute){
                            _$soundBtn.addClass("is-unmute");
                            _this.youtube.player.unMute();
                        }

                    }
                });

                if(!Useragnt.mobile) this.movie.$sound.on(_event,()=>{
                    if(!this.youtube.status.play) return;
                    if(!this.youtube.status.mute&&_$soundBtn.hasClass("is-unmute")){
                        _$soundBtn.removeClass("is-unmute");
                        this.youtube.status.mute = true;
                        this.youtube.player.mute();
                    }else{
                        _$soundBtn.addClass("is-unmute");
                        this.youtube.status.mute = false;
                        this.youtube.player.unMute();
                    }

                });

                // let _$productBg = $("#p-products-bg-view >*")
                // effect.bgImg(_$productBg,"set");
                // if(!Useragnt.mobile){

                //     $("#p-products-content-body li >*").on("mouseenter",function () {
                //         let _select = $(this).parent().data("target");

                //         if(_select==3) return;

                //         effect.bgImg(_$productBg.eq(_select),"show");

                //     }).on("mouseleave",function () {
                //         let _select = $(this).parent().data("target");

                //         if(_select==3) return;

                //         effect.bgImg(_$productBg.eq(_select),"out");
                //         _this.webgl.productBgchange(_this.page.status.current,_select)
                //         // _this.webgl.productBgchange(_select)

                //     });

                // }



                // this.youtube.player.addEventListener("onStateChange",function (e) {
                //     console.log("youtube",e)
                // });


                break;
        }

    }
    wheel(e,dir,type,startPoint){ /* wheel or touchmove イベント */



        // if(!this.page.status.modalFlg||!this.page.status.modalFlg&&type=="touch"&&startPoint.y - e.changedTouches[0].pageY>=10&&startPoint.y - e.changedTouches[0].pageY<=-10) e.preventDefault();

        if(!this.page.status.modalFlg&&type!="touch") e.preventDefault();


        if(!this.page.status.firstFlg||this.page.status.movieFlg||this.page.status.modalFlg) return;


        // let _timeDiff = e.timeStamp-this.status.update.timestamp;
        // this.status.update.timestamp = e.timeStamp;
        //
        // if(_timeDiff<500&&this.status.wheel.time<180) return;

        // console.log(this.status.wheel.time,e.originalEvent.deltaY,type,dir);


        if(this.status.wheel.time<this.conf.wheel.PAUSE) return;


        if(
            type=="mouse"&&dir=="next"&&e.originalEvent.deltaY<10&&!Useragnt.firefox||
            type=="mouse"&&dir=="prev"&&e.originalEvent.deltaY>-10&&!Useragnt.firefox||
            type=="touch"&&dir=="next"&&startPoint.y - e.changedTouches[0].pageY<10||
            type=="touch"&&dir=="prev"&&startPoint.y - e.changedTouches[0].pageY>-10

        ) return;

        // this.status.wheel.flg = true;
        this.status.wheel.time = 0;

        this.page.update(e,"",dir);
        this.webgl.change(this.page.status.current,this.page.status.prevCurrent);
        this.gNavi.update(this.page.status.current,this.page.status.prevCurrent);

    }
    render(){

        if(!requestAnimationFrame){
            setTimeout(()=>this.render,1000/60);
        }else{
            requestAnimationFrame(this.render.bind(this));
        }

        this.fpsRate = util.updateTimeRatio();


        // this.fps.begin();

        if(!this.loader.flg) this.loader.render();

        if(this.loader.flg){
            if(!this.page.status.firstStFlg){
                this.page.status.firstStFlg = true;
                setTimeout(()=>{
                    this.page.mainvisual.show()
                    this.page.status.firstFlg = true;
                },15e2)
            }
        }


        if(this.page.status.modalFlg) return;

        // this.scroll.move(this.fpsRate);
        this.mouse.move();
        this.webgl.render("",this.mouse.obj,this.fpsRate);
        if(this.page) this.page.render(this.mouse.obj);

        if(this.youtube.status.load&&this.youtube.status.play) this.movie.render(this.youtube.player.getCurrentTime(),this.mouse.obj);

        this.status.wheel.time +=1*this.fpsRate;

        // this.fps.end();

    }
    resize(){

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        // param.displayType = ( window.innerWidth>param.breakpoint )?"pc":"sp";
        // if(pageID==="top")toppage.resize();
        this.webgl.resize(this.w,this.h);
        // this.scroll.resize("");
        if(this.page) this.page.resize();

        if(this.page.status.modalFlg){
            TweenMax.set($("#p-movie,#l-body .p-section"),{height:this.h});
        }else{
            TweenMax.set($("#l-root,#p-movie,#l-body .p-section"),{height:this.h});
        }

    }
}